const config = Object.freeze({
  MaxBusinesses: 10,
});

export default config;
